import React from "react";
import { Link } from "react-router-dom";
import iconUrl from "@/assets/icon.png";

// Real OneLease door "1" mark cropped from the brand logo
export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img src={iconUrl} alt="OneLease" className={`${className} object-contain`} aria-hidden="true" />
);

export const Wordmark = ({ className = "text-xl", markClass = "h-9 w-9" }) => (
  <span className="inline-flex items-center gap-2.5">
    <LogoMark className={markClass} />
    <span className={`brand-word tracking-tight text-ol-deep ${className}`}>
      <b>One</b><span>Lease</span>
    </span>
  </span>
);

export const BrandLink = ({ className, markClass, textClass }) => (
  <Link to="/" className={`inline-flex items-center ${className || ""}`} data-testid="brand-home-link" aria-label="OneLease home">
    <Wordmark className={textClass} markClass={markClass} />
  </Link>
);

export default Wordmark;
